import type { CurrentUser } from '@app/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { qk } from '../../../lib/queryKeys';
import { authApi } from '../api/auth.api';

// Hook central de auth: cualquier componente que necesite saber quién está logueado.
// React Query maneja el cache; el interceptor de api.ts maneja refresh y redirect.
export function useCurrentUser(): UseQueryResult<CurrentUser, Error> {
  return useQuery({
    queryKey: qk.auth.me,
    queryFn: async () => {
      const r = await authApi.me();
      return r.user;
    },
    retry: false,
    staleTime: 5 * 60_000, // 5 min
  });
}
